var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfoIcon = function SvgInfoIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.41 19.64",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6B7785;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.71,.4C4.51,.4,.29,4.63,.29,9.82s4.23,9.42,9.42,9.42,9.42-4.23,9.42-9.42S14.9,.4,9.71,.4Zm0,16.84c-4.09,0-7.42-3.33-7.42-7.42S5.62,2.4,9.71,2.4s7.42,3.33,7.42,7.42-3.33,7.42-7.42,7.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.71,8.82c-.55,0-1,.45-1,1v3.37c0,.55,.45,1,1,1s1-.45,1-1v-3.37c0-.55-.45-1-1-1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.41,5.74c-.37-.37-1.04-.37-1.41,0-.09,.1-.17,.21-.22,.33-.05,.12-.07,.25-.07,.38s.02,.26,.07,.38c.05,.13,.13,.23,.22,.33,.18,.18,.44,.29,.71,.29s.52-.11,.7-.29c.1-.1,.17-.2,.22-.33,.05-.12,.08-.25,.08-.38s-.03-.26-.08-.38c-.05-.12-.12-.23-.22-.33Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "info-icon.2101c05de5462618ebe5e97f99b5d0d7.svg";